import { ChartProps } from '../types';
import { escapeHtml } from '@opengov/reporting-types/src/escapeHtml';

export function applyTitleOptions(options: Highcharts.Options, props: ChartProps) {
  if (props.title) {
    options.title = { ...options.title, text: escapeHtml(props.title) };
  }
  return options;
}

export function applyDescriptionOptions(options: Highcharts.Options, props: ChartProps) {
  if (props.description) {
    options.subtitle = { ...options.subtitle, text: escapeHtml(props.description) };
  }
  return options;
}
